<template>
  <div v-loading="loading">
      <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small" style="margin-right: 3vw">
          <el-row>
              <el-col :span="24">
                  <el-form-item label="公司名称：" prop="full_name" label-width="120px" style="height: 50%">
                      <el-input v-model="formData.full_name"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="公司简称：" prop="short_name" label-width="120px" style="height: 50%">
                      <el-input v-model="formData.short_name"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="公司介绍：" prop="company_desc" label-width="120px" style="height: 50%">
                      <Xheditor ref="editor1" id="editor1" :text="formData.company_desc" :fileID="fileID" :tableName="uploadForm.tableName" @change="change1"></Xheditor>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="业务领域：" label-width="120px" style="height: 50%">
                      <Xheditor ref="editor2" id="editor2" :text="formData.business_field" :fileID="fileID" :tableName="uploadForm.tableName" @change="change2"></Xheditor>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="排序：" prop="sort" label-width="120px" style="height: 50%">
                      <el-input-number v-model="formData.sort" controls-position="right" :min="0" :max="100000000"></el-input-number>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="公司LOGO：" label-width="120px" style="height: 50%">
                      <AttachmentUpload ref="fileUpload" :isShow="true"
                                        :objectID="formData.id"
                                        :UseType="1"
                                        :TableName="uploadForm.tableName"
                                        @input="getAttachList"
                                        :multiple="false"
                                        :MaxFileNum="1"
                                        :fileType="['jpeg', 'bmp','jpg','png','gif']" :fileSize="0.3" :isShowTip="true"></AttachmentUpload>
                      <AttachmentList ref="fileList"
                                      :objectID="formData.id"
                                      :UseType="1"
                                      :TableName="uploadForm.tableName"
                                      :ShowDelete="true"></AttachmentList>
                  </el-form-item>
              </el-col>
          </el-row>
      </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import Xheditor from "@/components/XhComponents/XhEditor";
import AttachmentList from "@/components/AttachmentList";
import AttachmentUpload from "@/components/AttachmentUpload";
export default {
    name: "",
    props: ["data", "title"],
    components: { Xheditor, AttachmentList, AttachmentUpload },
    data() {
        return {
            formData: this.data,
            rulesAdd: {
                full_name: [{ required: true, message: "必填项", trigger: "blur" }],
                short_name: [{ required: true, message: "必填项", trigger: "blur" }],
                sort: [{ required: true, message: "必填项", trigger: "blur" }],
                company_desc: [{ required: true, message: "必填项", trigger: "blur" }],
                business_field: [{ required: true, message: "必填项", trigger: "blur" }],
            },
            loading: false,
            fileID: this.data.id,
            uploadForm: {
                tableName: "t_member_main",
                state: false,//上传状态
            },
        }
    },
    methods: {
        addOrUpdate() {
            let that = this;
            that.$refs.formData.validate((valid) => {
                if (valid) {
                    that.$api.post("/Member/saveData", that.formData,
                        function (res) {
                            if (res.code === "200" && res.msg === "true") {
                                that.$emit("closeModal");
                                that.$message.success("保存成功");
                            } else {
                                that.$message.warning("保存失败");
                            }
                        },
                        function (res) {
                            that.$message.error("服务异常，信息出错");
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        change1(val) {
            this.formData.company_desc = val;
        },
        change2(val) {
            this.formData.business_field = val;
        },
        getAttachList() {
            this.$refs.fileList.GetAttachmentList();
        },
    },
    mounted() { },
    created() { },
    watch: {
        data: function () {
            this.formData = this.data;
        },
    }
}
</script>
<style scoped lang="less">

</style>
